import React from 'react';
import styles from './StudyNavigation.scss';
import LifecycleIndicator from 'components/common/Study/LifecycleIndicator';
import { Tabs } from 'components/common/Tabs/Tabs';
import { GoBack } from 'components/common/Link';

const StudyNavigation = props => {
    const style = props.fixedNav ? styles.stuckStudyNavContainer : styles.studyNavigationContainer;
    return (
        <div className={style} data-cy="StudyNavigation">
            <GoBack
                data-test-id='hyp-study-navigation-back'
                to={props.complion4FlagEnabled ? '/binders/study' : '/studies'}
                data-cy="StudyNavigation-studies"
            >
                Back to {props.complion4FlagEnabled ? 'Binders' : 'Studies'} List
            </GoBack>
            <div className={styles.studyHeader} data-cy="StudyNavigation-div">
                <StudyTitle
                    title={props.title}
                    type={props.type}
                />
                <LifecycleStage
                    className={styles.lifecycle}
                    withBackground={!!props.lifecycle}
                    stage={props.stage}
                />
            </div>
            <Tabs tabs={props.tabs} location={props.location} />
        </div>
    );
};



export default StudyNavigation;

export const StudyTitle = props => (
    <div data-cy="StudyNavigation-StudyTitle">
        <h1 data-cy="StudyNavigation-h1">
            {props.title}
        </h1>
        <h2 data-cy="StudyNavigation-h2">
            {props.type}
        </h2>
    </div>
);

export const LifecycleStage = props => (
    <div className={props.className} data-cy="StudyNavigation-LifecycleStage">
        <h2>
            Lifecycle Stage
        </h2>
        <LifecycleIndicator
            withBackground={props.withBackground}
            title={props.stage}
        />
    </div>
);
